import {useQuery} from '@tanstack/react-query';
import {OhdService} from '../services/ohdService';

export function useOhdMetrics(ohdOrgId: number | undefined, campaignId?: number) {
    return useQuery({
        queryKey: ['ohd-metrics', ohdOrgId, campaignId ?? 'latest'],
        queryFn: () => OhdService.getMetrics(ohdOrgId as number, campaignId),
        enabled: typeof ohdOrgId === 'number' && ohdOrgId > 0,
        staleTime: 5 * 60 * 1000,
    });
}
